import { useState, useEffect } from "react";
import "./App.css";

import Countdown from "./Countdown";
import Subtitle from "./Subtitle";

const EW_EPOCH = 1638522000;

export default function App() {
  const [now, setNow] = useState(Date.now());
  const timeLeft = new Date(EW_EPOCH * 1000) - now;

  // update every half second
  useEffect(() => {
    setInterval(() => {
      setNow(Date.now());
    }, 500);
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <Countdown t={timeLeft} />
        <Subtitle t={timeLeft} />
      </header>
    </div>
  );
}
